// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"34":"component---src-pages-page-not-found-tsx","351":"commons","532":"styles","774":"framework"}[chunkId] || chunkId) + "-" + {"34":"d485f15ce50c2cf86da1","351":"f3c159db803d2ec1c78c","532":"ef33b0e2275f82323583","589":"81bc8c7bb91dee80d332","774":"5225a81720627d367d30"}[chunkId] + ".js";
};